import React from "react";
import ReactDOM from "react-dom";
import {Provider} from 'react-redux';
import {ToastProvider} from "react-toast-notifications";
import "./css/combined.css";
import "./css/updatesAndFixes.css";

import "./css/index.css";
import "./css/index_updates.css";
import "./css/bootstrap.bundle.min";

import store from './store';
import App from "./App";
import {initFacebookSdk, fbAsyncInit} from "./components/layout/lib/facebookInit";
import ErrorBoundary from "./components/meta/ErrorBoundary";
import TagManager from "react-gtm-module";

window.fbAsyncInit = fbAsyncInit;
initFacebookSdk();

const tagManagerArgs = {
    gtmId: 'GTM-WTN34R4',
    dataLayerName: 'dataLayer',
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <Provider store={store}>
        {/*window.bubblyWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS, window.bubblyWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS_TIMEOUT*/}
        <ToastProvider autoDismiss={true} autoDismissTimeout={6000} placement="bottom-center">
            <ErrorBoundary boundaryName="App Component">
                <App/>
            </ErrorBoundary>
        </ToastProvider>
    </Provider>,
    document.getElementById("root"));